import { render } from "./SidebarBeneficiarioComponent.vue?vue&type=template&id=5ceb002f&scoped=true"
import script from "./SidebarBeneficiarioComponent.vue?vue&type=script&lang=js"
export * from "./SidebarBeneficiarioComponent.vue?vue&type=script&lang=js"

import "./SidebarBeneficiarioComponent.vue?vue&type=style&index=0&id=5ceb002f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ceb002f"]])

export default __exports__